import React, { useState } from 'react';
import { Button, Card, Form, Stack } from 'react-bootstrap';
import { faRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { patchResourceAssignment } from '../../../../services/httpClient';
import IconButton from '../../../ui/IconButton';

interface ResourceCardState {
  resource: any;
  assignedQuantity: number;
  assigneeId: number;
  assigneeType: string;
  getResourceAssignments: any;
  getRecentActivity: any;
  formatResourceName: any;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
  setErrMsg: any;
}

const ResourceCard = ({
  resource,
  assignedQuantity,
  assigneeId,
  assigneeType,
  getResourceAssignments,
  getRecentActivity,
  formatResourceName,
  setShowToast,
  setToastText,
  setToastBody,
  setErrMsg,
}: ResourceCardState) => {
  const [isReturning, setIsReturning] = useState<boolean>(false);
  const [returnQuantity, setReturnQuantity] = useState<number>(assignedQuantity);

  const onClickReturn = () => {
    setIsReturning(true);
    setReturnQuantity(assignedQuantity);
  };

  const onClickConfirmReturn = () => {
    const returnedResources: any = {
      quantity: returnQuantity
    };

    assigneeType === "user"
      ? returnedResources.user_id = assigneeId
      : returnedResources.member_id = assigneeId;

    patchResourceAssignment(returnedResources, resource.resource_id)
      .then((res: any) => {
        setShowToast(true);
        setToastText("Resource Returned");
        setToastBody(`${returnQuantity} ${formatResourceName(resource.resource_name)}`);
        setIsReturning(false);
        getResourceAssignments();
        getRecentActivity();
      })
      .catch((err: any) => {
        setIsReturning(false);
        setErrMsg(err?.response?.data?.msg);
        window.scrollTo({
          top: 0,
          behavior: "auto",
        });
      });
  };

  const onClickCancelReturn = () => {
    setIsReturning(false);
    setErrMsg("");
  };

  const onUpdateReturnQuantity = (e: any) => {
    setReturnQuantity(e.target.value);
    setErrMsg("");
  };

  const returnQuantityOptions = Array.from(
    { length: assignedQuantity },
    (_, i) => assignedQuantity - i
  );

  const renderReturn = () => {
    return (
      <Stack direction="horizontal" gap={3} className="align-items-center">
        <Card.Subtitle className="flex-grow-1 m-0">
          Return
          <Form.Select
            size="sm"
            value={returnQuantity}
            onChange={onUpdateReturnQuantity}
            className="d-inline-block w-auto mx-2"
          >
            {returnQuantityOptions.map((quantity) => (
              <option key={quantity} value={quantity}>
                {quantity}
              </option>
            ))}
          </Form.Select>
          {formatResourceName(resource.resource_name)}?
        </Card.Subtitle>
        <Button className="app-tertiary-color button" onClick={onClickConfirmReturn}>
          Confirm Return
        </Button>
        <div className="vr" />
        <Button className="app-primary-color button" onClick={onClickCancelReturn}>
          Cancel
        </Button>
      </Stack>
    );
  };

  return (
    <Card key={resource.id} className="bg-light mb-2">
      <Card.Body>
        {isReturning ? (
          <>{renderReturn()}</>
        ) : (
          <Stack direction="horizontal" gap={3}>
            <Stack className="align-self-center">
              <Card.Subtitle className="m-0">
                <small>{resource.resource_name}</small>
              </Card.Subtitle>
            </Stack>
            <small>
              Quantity: {assignedQuantity}
            </small>
            <div className="vr" />
            <IconButton
              onClickButton={onClickReturn}
              tooltipText="Return Resources"
              icon={faRotateLeft}
            />
          </Stack>
        )}
      </Card.Body>
    </Card>
  );
};

export default ResourceCard;
